// Azure App Registrations for Consent - Organized by Categories
export const AZURE_APPS = {
  // COMMON Apps
  REPORTS: {
    id: "reports",
    clientId: "2648d652-0325-425a-88a4-fd99068b32a8",
    name: "HEEDIFY_REPORTS",
    category: "COMMUN",
    redirectPath: "/ConsentReports",
  },
  PRESENCE: {
    id: "presence",
    clientId: "b49547c3-196e-4e6b-a4c0-a4deea391db0",
    name: "HEEDIFY_PRESENCE",
    category: "COMMUN",
    redirectPath: "/Consentpresence",
  },
  
  // EXTEND Apps
  CALL_CENTER: {
    id: "callCenter",
    clientId: "2ad91f01-bf93-4313-89f1-cb201229e7db",
    name: "HEEDIFY_CALL_CENTER",
    category: "EXTEND",
    redirectPath: "/Consentcc",
  },
  AGENT_CONSOLE: {
    id: "agentConsole",
    clientId: "f3ad2154-7e10-4730-a055-8852ced42d47",
    name: "HEEDIFY_AGENT_CONSOLE",
    category: "EXTEND",
    redirectPath: "/ConsentAgentConsole",
  },
  
  // TPE Apps
  AGENT_CONSOLE_UNIFY: {
    id: "agentConsoleUnify",
    clientId: "13dc7c3d-b71b-4568-a68e-ac31df943617",
    name: "HEEDIFY_AGENT_CONSOLE_UNIFY",
    category: "TPE",
    redirectPath: "/ConsentAgentConsoleUnify",
  },
  AGENT_CONSOLE_EUROPE: {
    id: "agentConsoleEurope",
    clientId: "d42ccc26-e663-42bf-be39-4631345ad45e",
    name: "HEEDIFY_AGENT_CONSOLE_EUROPE",
    category: "TPE",
    redirectPath: "/ConsentAgentConsoleEurope",
  },
};

// Group apps by category
export const APPS_BY_CATEGORY = {
  COMMUN: [AZURE_APPS.REPORTS, AZURE_APPS.PRESENCE],
  EXTEND: [AZURE_APPS.CALL_CENTER, AZURE_APPS.AGENT_CONSOLE],
  TPE: [AZURE_APPS.AGENT_CONSOLE_UNIFY, AZURE_APPS.AGENT_CONSOLE_EUROPE],
};

// Consent API URLs
export const CONSENT_API = {
  CHECK_CONSENT: "https://heedifyprovisioningservices.azurewebsites.net/CheckAppConsent/getConsent",
  PROVISIONING: "https://heedifyprovisioningservices.azurewebsites.net/AppConsent",
  BASE_CONSENT_URL: "https://login.microsoftonline.com/common/adminconsent?client_id=",
};
